var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v(_vm._s(_vm.section.description))]),_vm._v(" "),_vm._t("top"),_vm._v(" "),_vm._l((_vm.section.children),function(entity){return _c(_vm.typeToComponent(entity.field.type),{key:entity.id,tag:"component",attrs:{"entity":entity}})}),_vm._v(" "),_vm._t("bottom")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c4d74e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-components/activity-summary/components/custom-section/custom-section.vue
// module id = 7/9U
// module chunks = 1